import { Navigate, type RouteObject } from 'react-router-dom';
import { AppShell } from './AppShell';
import { StartView } from '../workspaces/start/StartView';
import { MainView } from '../workspaces/main/MainView';
import { BackstageView } from '../workspaces/backstage/BackstageView';
import { SettingsView } from '../workspaces/settings/SettingsView';
import { BrandGalleryView } from '../workspaces/brand/BrandGalleryView';
import { FeedbackLoopPresentationView } from '../workspaces/backstage/tabs/story/feedback-loop/FeedbackLoopPresentationView';

/**
 * Sprint 20 M2 — five-plane route table.
 *
 * The surface elements are being replaced by the real Start / Main / CSA /
 * Backstage / Settings surfaces in M5. The router is mounted in `App.tsx`
 * (M4 cutover), once the legacy `TopBar`/`AppRail`/`WorkspaceRouter` shell was
 * removed.
 */
export const routes: RouteObject[] = [
  {
    path: 'present/feedback-loop',
    element: <FeedbackLoopPresentationView />,
  },
  {
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/start" replace /> },
      { path: 'start', element: <StartView /> },
      { path: 'main/:board?', element: <MainView /> },
      { path: 'backstage/:widget?', element: <BackstageView /> },
      { path: 'settings', element: <SettingsView /> },
      { path: 'brand', element: <BrandGalleryView /> },
      { path: '*', element: <Navigate to="/start" replace /> },
    ],
  },
];
